import { AnalyticsEvent } from '../models';

export class HomePageLoadEvent implements AnalyticsEvent {
  name = 'HomePageLoadEvent';

  constructor(public readonly isTopLevelMenuInView?: boolean) {}
}
